import { useMutation, useQuery } from '@tanstack/react-query';
import {
  GetMyTeamInfoAPIResponse,
  GetScoreboardTeamsAPIRequest,
  GetScoreboardTeamsAPIResponse,
} from './types';
import axios, { AxiosError } from 'axios';
import { env } from 'core/env';
import { useAuth } from 'core/contexts/authContext';
import { getNetworkErrorInfo } from 'functions/getNetworkErrorInfo';
import toast from 'react-hot-toast';

const useUserQueries = () => {
  const { token } = useAuth();

  const getMyTeamInfoMutation = useMutation<
    GetMyTeamInfoAPIResponse,
    AxiosError
  >({
    mutationFn: async () => {
      const response = await axios.get<GetMyTeamInfoAPIResponse>(
        env.API_URL_SCOREBOARD_ME,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    },
    onError: error => {
      const errorInfo = getNetworkErrorInfo(error);
      console.log('HERE', JSON.stringify(errorInfo));

      let errorMessage: string;

      if (typeof errorInfo.message === 'string') {
        errorMessage = errorInfo.message;
      } else {
        const firstError = errorInfo.message[0];
        errorMessage =
          firstError?.msg ||
          'Error getting info, please try to reload the window';
      }

      toast.error(errorMessage);
    },
  });

  const useGetScoreboardTeamsQuery = (
    params?: GetScoreboardTeamsAPIRequest
  ) => {
    return useQuery<GetScoreboardTeamsAPIResponse, AxiosError>({
      queryKey: ['getScoreboardTeams', params],
      queryFn: async () => {
        const response = await axios.get<GetScoreboardTeamsAPIResponse>(
          env.API_URL_SCOREBOARD_TEAMS,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            params,
          }
        );

        return response.data;
      },
      enabled: !!token,
    });
  };

  return {
    getMyTeamInfoMutation,
    useGetScoreboardTeamsQuery,
  };
};

export default useUserQueries;
